// Format a "HH:MM" (24h) time_of_day string to 12h with AM/PM, and optionally
// append the end time computed from a duration in minutes: "7:00 AM – 8:00 AM".
export const to12h = (t) => {
  const m = /^\s*(\d{1,2}):(\d{2})/.exec(t || '');
  if (!m) return t || '';
  const h = Number(m[1]);
  const ap = h >= 12 ? 'PM' : 'AM';
  return `${h % 12 || 12}:${m[2]} ${ap}`;
};

export const todRange = (tod, durationMin) => {
  const m = /^\s*(\d{1,2}):(\d{2})/.exec(tod || '');
  if (!m) return tod || '';
  const start = to12h(tod);
  if (!durationMin) return start;
  const total = Number(m[1]) * 60 + Number(m[2]) + Number(durationMin);
  const eh = Math.floor(total / 60) % 24;
  const em = total % 60;
  const ap = eh >= 12 ? 'PM' : 'AM';
  return `${start} – ${eh % 12 || 12}:${String(em).padStart(2, '0')} ${ap}`;
};
